if (!window.__newsletterTrackingLoaded) {
  window.__newsletterTrackingLoaded = true;

  document.addEventListener("DOMContentLoaded", function () {
    function trackNewsletterSignup(form) {
      if (form.__alreadyTracked) return;
      form.__alreadyTracked = true;

      const emailInput = form.querySelector('input[type="email"]');
      const email = emailInput?.value || undefined;

      let source = "unknown";
      if (form.closest("#newsletter-popup")) source = "popup";
      else if (form.closest(".footer-block__newsletter")) source = "footer";

      Shopify.analytics.publish("newsletter_signup", {
        email: email,
        source: source,
      });
    }

    document.addEventListener("submit", function (e) {
      const form = e.target;
      const hasNewsletterId =
        typeof form.id === "string" && form.id.includes("newsletter");

      if (form.matches('[action*="/contact"]') || hasNewsletterId) {
        trackNewsletterSignup(form);
      }
    });

    document.addEventListener("click", function (e) {
      const btn = e.target.closest(
        'button[type="submit"], input[type="submit"]'
      );
      if (!btn) return;

      const form = btn.closest("form");
      const hasNewsletterId =
        form && typeof form.id === "string" && form.id.includes("newsletter");

      if (form && (form.matches('[action*="/contact"]') || hasNewsletterId)) {
        setTimeout(() => trackNewsletterSignup(form), 50);
      }
    });
  });
}